import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src829137711/src/Divine-infinite-ui-next/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src829137711/src/Divine-infinite-ui-next/node_modules/next/dist/client/link.js");
